<template>
  <div class="popupContainer">
    <div class="popupContent" @click="onClose" v-if="isModalShown">
      <img :src="cancel" alt="" class="pointer" @click="onClose">
      <div class="body">
        <h3>Withdraw Rules:</h3>
        <div v-html="withdrawalRules"></div>
      </div>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/images/common/cancel_black.svg'

export default {
  name: 'Modal',
  props: {
    isModalShown: Boolean,
    onCloseFunc: Function,
    withdrawalRules: String
  },
  data () {
    return {
      cancel
    }
  },
  methods: {
    onClose () {
      this.$emit('toggleModalShownStatus')
    }
  }
}
</script>

<style lang="less" scoped>
  .popupContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .popupContent {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80%;
      transform: translate(-50%,-50%);
      >img {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 28px;
      }
      .body {
        color: #F6D9AA;
        background: #212324;
        border-radius: 0 0 10px 10px;
        width: 80vw;
        height: 60vh;
        padding: 30px;

        h3 {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/index.vue